"use client";

import React from "react";
import Image from "next/image";
import {Percent} from "lucide-react";
import Link from "next/link";
import NoImage from "@/public/no-image.jpg";
import {IProductCartItemImageHalfProps} from "@/types/ProductCartItemImageHalfProps";
import AddToBasketProductCard from "@/components/ui/card/add-to-basket-product-card";
import TotalQuantityCardComponent from "@/components/totalQuantityCardComponent";

function ProductCartItemImageFull({
                                      sale_price,
                                      unique_id,
                                      slug,
                                      title,
                                      price,
                                      seller_title,
                                      total_quantity,
                                      discount_percentage,
                                      image,
                                      id,
                                      product_item_id,
                                      replace_title,
                                      replace_unique_id,
                                      replace_slug,
                                      min_total_qty_and_max_basket_qty,
                                      max_basket_limit,
                                  }: IProductCartItemImageHalfProps) {

    return (
        <article dir="rtl"
                 className="w-full overflow-hidden p-2 border-none md:p-4 flex flex-wrap items-center justify-center h-full shadow-none rounded-2xl relative">
            <Link target="_blank" href={`/product/${unique_id || replace_unique_id}/${slug || replace_slug}`}
                  className="hidden w-full md:flex items-center justify-center">
                {!image ? (
                    <div className="w-[151px] h-[151px] flex items-center justify-center bg-gray-200">در حال
                        بارگذاری...</div>
                ) : (
                    <Image
                        loading="lazy"
                        className="w-[151px] h-[151px] transition-all hover:scale-105"
                        width={151}
                        height={151}
                        src={image ? image : NoImage}
                        alt={title ?? "A description of the image"}
                        title={title ?? "A description of the image"}
                    />
                )}
            </Link>

            <Link target="_blank" href={`/product/${unique_id}/${slug}`}
                  className="w-full flex md:hidden items-center justify-center">
                <Image
                    loading="lazy"
                    className="w-[133px] h-[133px]"
                    width={133}
                    height={133}
                    src={image ? image : NoImage}
                    alt={title ?? "A description of the image"}
                    title={title ?? "A description of the image"}
                />
            </Link>

            {price ? (
                <section className="w-full px-1 md:px-0 flex flex-wrap content-between justify-center">
                    <Link target="_blank" href={`/product/${unique_id}/${slug}`} className="w-full flex flex-wrap">
                        <h2 className="text-xs md:text-[17px] w-full line-clamp-2 leading-[18px] md:leading-7 truncate text-start text-wrap font-bold">{title}</h2>
                        <div className="w-full flex flex-wrap items-center py-1.5 text-xs md:text-base">
                            <span className="text-past-price text-xs md:text-sm font-medium">فروشنده:</span>
                            <div className="flex-wrap flex gap-1 px-1">
                                <h4 className="text-xs md:text-sm text-global-text-color"> {seller_title}</h4>
                            </div>
                        </div>
                        <div
                            className="w-full  line-clamp-1 text-orange-primary font-medium text-[10px] md:text-xs flex items-center h-[20px]">
                            {total_quantity as any < 21 && <TotalQuantityCardComponent count={total_quantity}/>}
                        </div>
                    </Link>
                    <section className="w-full flex flex-wrap items-center">
                        <div className="w-1/3 flex items-end md:p-1">
                            <AddToBasketProductCard
                                price={Number(price)}
                                product={{
                                    sale_price,
                                    unique_id,
                                    slug,
                                    id,
                                    product_item_id,
                                    title,
                                    quantity: 1,
                                    total_quantity,
                                    seller_title,
                                    discount_percentage,
                                    price,
                                    image: image ? image : NoImage,
                                    active: true,
                                    max_basket_limit: max_basket_limit,
                                    min_total_qty_and_max_basket_qty: min_total_qty_and_max_basket_qty
                                }}
                            />
                        </div>

                        <div className="w-2/3 p-1 flex flex-wrap">
                            {!!discount_percentage && (
                                <div
                                    className="flex items-center justify-end text-xs w-full my-1 gap-1 md:gap-2 flex-wrap">
                                    <del
                                        className="text-past-price text-xs md:text-base font-medium">{price?.toLocaleString("fa")}</del>
                                    <div
                                        className="w-[32px] h-[18px] text-white items-center text-xs font-medium justify-center flex rounded-[5px] bg-[#E50101]">
                                        {Math.floor(Number(discount_percentage))?.toLocaleString("fa")}
                                        <Percent className="w-3 h-3"/>
                                    </div>
                                </div>
                            )}

                            <div
                                className="w-full flex text-sm items-center justify-end gap-1 font-black md:text-xl text-global-text-color">
                                {Math.round(+sale_price)?.toLocaleString("fa")}
                                <span className="text-xs md:text-md">تومان</span>
                            </div>
                        </div>
                    </section>
                </section>
            ) : (
                <div className="w-full px-1 md:px-2 flex flex-wrap content-between justify-center">
                    <h2 className="text-xs md:text-lg w-full line-clamp-2 leading-7 truncate text-start text-wrap font-bold">{replace_title}</h2>
                    <div
                        className="text-xl text-past-price w-full flex justify-end pt-6 absolute bottom-2 left-2">ناموجود
                    </div>
                </div>
            )}
        </article>
    );
}

export default ProductCartItemImageFull;